export const dataPerPage = "10";
export const imagePerPage = "20";
export const appCurrency = "€";
export const MobileBreakPoint = "900";
export const MobileOverBreakPoint = "901";
export const PortalEncrypt = "constgloba";
export const MobileLandingBreakPoint = "700";
export const MobileLandingOverBreakPoint = "701";
export const AESkey = "Ceci@2021-2022";
